import React, { ReactNode, CSSProperties } from 'react';

interface Props {
  style?: CSSProperties;
  children: ReactNode;
}

/**
 * Prevent inner click events bubbling (propagation) to outer elements
 * Note: it does stop only onClick events right now
 */
const StopEventPropagationDiv = ({ children, style }: Props) => {
  return (
    <div onClick={event => event.stopPropagation()} style={style}>
      {children}
    </div>
  );
};

export default StopEventPropagationDiv;
